<template>
  <div>
    <div class="form_box">
      <el-table empty-text="暂无数据" :data="tableData" border>
        <el-table-column label="报案用户" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.reportUser}}
          </template>
        </el-table-column>
        <el-table-column label="用户手机号" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.reporterContact}}
          </template>
        </el-table-column>
        <el-table-column label="报案时间" min-width="50">
          <template slot-scope="scope">
            {{setTime(scope.row.obj.reportTs)}}
          </template>
        </el-table-column>
        <el-table-column label="出险人" min-width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.victimList.length != 0">
              {{scope.row.victimList[0].obj.victimName}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="place" label="出险地" min-width="50">
          <template slot-scope="scope">
            {{setTxt(scope.row.generalLocation.addr)}}
          </template>
        </el-table-column>
       <el-table-column  label="出险人保障" min-width="50">
         <template slot-scope="scope">
           {{statusObj[scope.row.obj.caseInsured]}}
         </template>
       </el-table-column>
        <el-table-column prop="source" label="案件来源" min-width="50">
          <template slot-scope="scope">
            {{scope.row.obj.caseSrc}}
          </template>
        </el-table-column>
        <el-table-column prop="op" label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button v-if="userType == 1" type="text" size="small" @click="tores(scope.row)">确认案件已完成</el-button>
            <el-button v-if="userType == 1" type="text" size="small" @click="dialogFormVisible1 = true;caseId=scope.row.obj.id">关闭星使派单</el-button>
            <el-button v-if="userType == 5 || userType == 4" type='text' @click="openWork(scope.row.obj.id)">加入协调</el-button>
            <el-button type='text' @click='topathDetail(scope.row.obj.id,scope.row.obj.initialCaseId)'>案件详情</el-button>
            <router-link :to="{name:'newstar1',params:{caseList:scope.row}}">案件编辑</router-link>
            <el-button type="text" size="small" @click="showcooperaterDialogVisible = true;caseId=scope.row.obj.id;listDomestic(scope.row.obj.id)">修改协调人</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="确认完成案件" center :visible.sync="dialogFormVisible" width="800px">
      <div class="popBox">
        <p style="margin-bottom: 15px">救援费用:</p>
        <ul>
          <li>
            <span>救援费用</span>
            <el-input type="text" v-model="rescueFee"></el-input>
            <span>RMB</span>
          </li>
          <li>
            <span>医疗费用</span>
            <el-input type="text" v-model="medicFee"></el-input>
            <span>RMB</span>
          </li>
          <li>
            <span>其他费用</span>
            <el-input type="text" v-model="otherFee"></el-input>
            <span>RMB</span>
          </li>
        </ul>
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button @click="dialogFormVisible = false">取 消</el-button>
    		<el-button type="primary" @click="sureFun()">确 定</el-button>
    	</div>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog title="修改协调人" :visible.sync="showcooperaterDialogVisible" center top="1vh" width="1000px" @close="toggleSelection()">
       <span class="contactAddStyle" @click="addContacterDialogVisible=true"></span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="修改协调人" name="second">
          <el-table empty-text="暂无数据" :data="cooperaterData" class="mgt15" border @selection-change="handleSelectionChange" ref="multipleTable">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="30"></el-table-column>
            <el-table-column prop="mobileNo" label="手机号" min-width="30"></el-table-column>
            <el-table-column prop="nationalId" label="证件号码" min-width="30"></el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 10px;">
            <el-button type="primary" @click='diffDomestic()'>确定</el-button>
            <el-button @click='toggleSelection();showcooperaterDialogVisible=false'>取消</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="非公司隶属的协调人" name="first">
          <el-table empty-text="暂无数据" :data="cooperaterData1" class="mgt15" border @selection-change="handleSelectionChange1" ref="multipleTable1">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="30"></el-table-column>
            <el-table-column prop="mobileNo" label="手机号" min-width="30"></el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 10px;">
            <el-button type="primary" @click="diffNormalUser()">确定</el-button>
            <el-button @click='toggleSelection1();showcooperaterDialogVisible=false'>取消</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog title="关闭星使派单" center :visible.sync="dialogFormVisible1" width="500px">
			<center>是否确认关闭？</center>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="closeCase()">确 定</el-button>
			</div>
		</el-dialog>
    <!-- 添加新注册的协调人 -->
    <el-dialog title="添加新协调人" center :visible.sync="addContacterDialogVisible" width="500px">
    	<div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input v-model="victimName" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
        <div style="margin-top: 10px;">
          手机号：<el-input v-model="nationalMobile" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button @click="addContacterDialogVisible = false">取 消</el-button>
    		<el-button type="primary" @click="newDJXid()">确 定</el-button>
    	</div>
    </el-dialog>
  </div>
</template>

<script>
  import { xingshiGong,getfinishSureCase,listSubUser,diffDomestic,listDomestic,removeDomestic,closeCase,listNormalUser,diffNormalUser,creatBasic,joinCoord } from '@/views/axios/api.js'
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        tableData: [],
        token: JSON.parse(window.localStorage.getItem("data")).data,
        dialogFormVisible:false,
        totalFee:'',
        rescueFee:'',
        medicFee:'',
        otherFee:0,
        caseId:'',
        userType:JSON.parse(window.localStorage.getItem("insti")).type,
        showcooperaterDialogVisible: false,//添加
        cooperaterData:[],//所有联系人
        cooperaterData1:[],//所有联系人
        cooperaterDataList:[],//当前案件未修改之前的记录
        cooperaterDataListCheck:[],//当前案件修改之后
        dialogFormVisible1:false,
        statusObj:['在保','无保','在保','旅责险'],
        activeName: 'second',
        tabBtn:true,
        ruserDataListCheck:[],
        addContacterDialogVisible:false,
        victimName:'',
        nationalMobile:'',
      };
    },
    methods: {
      setTxt(str, status) {
      	if (constants.setTxt(str, status)) {
      		return constants.setTxt(str, status);
      	} else {
      		return str;
      	}
      },
      setTime(str) {
        return constants.time(str)
      },
       handleClick(tab, event) {
         console.log(tab);
      },
      topathDetail(id1,glId){
        let path='',id=''
        if(this.userType == 1){
          path='/cmd_center/caseDetails';
          id=glId
        }else{
          path='/branch/starindex/starsdetail';
          id=id1
        }
        this.$router.push({
          path,
          query:{caseid:id}
        })
      },
      listSubUser(){
        var data={
          token:this.token,
          start:0,
          count:100,
          all:1
        }
        listSubUser(data)
        .then(res => {
          console.log(res);
          this.cooperaterData=res.data.obj;
        })
        .catch(err => {
          console.log(err);
        })
      },
      handleSelectionChange(val){
        this.cooperaterDataListCheck=val;
      },
      handleSelectionChange1(val){
        this.ruserDataListCheck=val;
      },
      removeDomestic(id){
        var data={
          token:this.token
        }
        removeDomestic(data,id)
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
      },
      getData() {
        var status='status=230';
        if(this.userType == 4){
          status='status=230&status=211'
        }else if(this.userType == 1){
          status='status=230&status=211&status=210'
        }
        var data = {
          token: this.token,
          typeId: 600
        }
        xingshiGong(data,status)
          .then(res => {
            console.log(res);
            this.listSubUser()
            this.tableData=res.data.obj
          })
          .catch(err => {
            console.log(err);
          })
      },
      closeCase(){
        var data={
          token:this.token,
          caseId:this.caseId
        }
        closeCase(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('案件已关闭')
            this.getData()
            this.dialogFormVisible1=false
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      listDomestic(id){
        var data={
          token:this.token,
          start:0,
          count:100,
          caseId:id
        }
        listDomestic(data)
        .then(res => {
          this.cooperaterDataList=res.data.obj;
          var cooperaterDataList=[]
          this.cooperaterDataList.forEach(item => {
            this.cooperaterData.forEach(item1 => {
              if(item1.id == item.id){
                cooperaterDataList.push(item1)
              }
            })
          })
          this.cooperaterDataList=cooperaterDataList
          this.toggleSelection(cooperaterDataList)
        })
        .catch(err => {
          console.log(err);
        })
        var data1={
          token:this.token,
          caseId:id
        }
        listNormalUser(data1)
        .then(res => {
          console.log(res);
          this.cooperaterData1=res.data.obj;
          setTimeout(() => {
            this.toggleSelection1(this.cooperaterData1)
          }, 500);
        })
        .catch(err => {
          console.log(err);
        })
      },

      diffDomestic(){
        var fids=''
        this.cooperaterDataListCheck.forEach((item,index) => {
             fids+='fids='+ item.id+'&'
        })
        var oids=''
        this.cooperaterDataList.forEach((item,index) => {
          if(index < this.cooperaterDataList.length - 1){
             oids+='oids='+ item.id+'&'
          }else{
             oids+='oids='+ item.id
          }
        })
        var data={
          token:this.token,
          caseId:this.caseId
        }
        diffDomestic(data,fids,oids)
        .then(res => {
          if(res.data.code == 0){
            this.showcooperaterDialogVisible=false;
            this.$message.success('添加成功')
            this.getData()
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
      },
      diffNormalUser(){
        var fids=''
        this.ruserDataListCheck.forEach((item,index) => {
          if(index < this.ruserDataListCheck.length - 1){
             fids+='fids='+ item.id+'&'
          }else{
             fids+='fids='+ item.id
          }
        })
        var data={
          token:this.token,
          caseId:this.caseId
        }
        diffNormalUser(data,fids)
        .then(res => {
          if(res.data.code == 0){
            this.showcooperaterDialogVisible=false;
            this.$message.success('添加成功')
            this.getData()
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
      },
      tores(obj){
        console.log(obj);
        this.caseId=obj.obj.id
        this.dialogFormVisible=true
        // this.totalFee=obj.obj.totalFee ;
        this.medicFee=obj.obj.medicFee || 0;
        this.otherFee=obj.obj.otherFee || 0;
        this.rescueFee=obj.obj.rescueFee || 0;
      },
      sureFun(){
        this.totalFee=Number(this.medicFee)+Number(this.otherFee)+Number(this.rescueFee)
        var data={
          token:this.token,
          id:this.caseId,
          totalFee:this.totalFee,
          medicFee:this.medicFee,
          otherFee:this.otherFee,
          rescueFee:this.rescueFee
        }
        getfinishSureCase(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('操作成功')
            this.getData();
            this.dialogFormVisible=false
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      toggleSelection(rows) {
        console.log(rows);
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      toggleSelection1(rows) {
        console.log(rows);
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable1.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable1.clearSelection();
        }
      },
      //创建大救星账户
      newDJXid() {
        if(this.victimName==''){
      		return this.$message.error("出险人姓名不能为空");
      	}else if(this.nationalMobile==''){
      		return this.$message.error("手机号不能为空")
      	}
        var data={
          token:this.token,
          name:this.victimName,
          nationalMobile:this.nationalMobile
        }
        creatBasic(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('创建成功')
            this.addContacterDialogVisible=false;
            this.cooperaterData1.push(res.data.obj)
            this.victimName='';
            this.nationalMobile='';
          }else{
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      openWork(caseId) {
        joinCoord({token:this.token,caseId},'')
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
        this.$store.commit('caseIdFun', caseId);
        this.$store.commit('workBtnFun', true);
      }
    },
    mounted() {
      this.getData()
    }
  };
</script>

<style scoped>
.popBox li{margin-bottom: 10px;}
.popBox .el-input{width: 300px;}
.contactAddStyle{position: absolute; top: 90px;right: 20px;cursor: pointer;z-index: 9;}
.contactAddStyle::before{
		content: '+';
		color: #00ABF9;
		width: 15px;
		height: 15px;
		display: inline-block;
		border-radius: 7.5px;
		text-align: center;
		line-height: 15px;
		font-size: 16px;
		margin-right: 5px;
		border: 1px solid #00ABF9;
	}
</style>


// WEBPACK FOOTER //
// src/components/cmd_center/star/underway.vue